'use client';

import { getSocialLinks } from '@/services/storeService';
import { usePathname } from 'next/navigation';
import React from 'react';
import Image from 'next/image';

export const WhatsAppIcon: React.FC = () => {
  const pathname = usePathname();

  const blockedExact = ['/checkout', '/cart', '/signin'];
  const blockedPrefixes = ['/p/', '/products/'];

  const isBlocked =
    blockedExact.includes(pathname) ||
    blockedPrefixes.some((prefix) => pathname.startsWith(prefix));

  if (isBlocked) return null;

  const socials = getSocialLinks();
  if (!socials?.length) return null;


  const whatsapp = socials.find((s: any) => {
    const nameLower = s.name?.toLowerCase();
    return nameLower?.includes('whatsapp') && s.status === 1; // Fixed: 1 instead of true
  });

  if (!whatsapp) {
    return null;
  }

  return (
    <a
      href={whatsapp.value}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed z-30 bottom-4 left-4"
      style={{ textDecoration: 'none' }}
    >
      <Image
        src="https://blr1.digitaloceanspaces.com/assetsvilva/vilvabusiness/website/common/otherallimages/whatsappIconOfEcom.webp"
        alt="WhatsApp Chat"
        width={55}
        height={55}
        className="object-contain drop-shadow-lg transition-transform hover:scale-110"
        loading="lazy"
      />
    </a>
  );
};
